import { CSSProperties, ReactNode, useState } from 'react';
import { Text, TextProps } from '@mantine/core';
import { useEventListener } from '@mantine/hooks';

import { Tooltip, TooltipProps } from './Tooltip';

type TextWithTooltipProps = {
  // children to be wrapped by tooltip component
  children: ReactNode;
  // Tooltip props, see custom Tooltip component
  tooltipProps?: Partial<TooltipProps>;
  // Text props for MantineUI Text component, see https://mantine.dev/core/text/?t=props
  textProps?: TextProps;
  // Tooltip is permanently shown
  style?: CSSProperties;
};

// appends a tooltip to children node
// Use textProps lineClamp to show a tooltip for clamped text only!
export function TextWithTooltip({
  children,
  tooltipProps,
  textProps,
  style,
}: TextWithTooltipProps) {
  const [disabled, setDisabled] = useState(true);
  const ref = useEventListener('mouseover', () => {
    if (ref.current) {
      setDisabled(ref.current.scrollHeight <= ref.current.clientHeight);
    }
  });

  return (
    <Tooltip
      label={tooltipProps?.label ?? children}
      {...tooltipProps}
      disabled={tooltipProps?.disabled ?? disabled}
    >
      <Text inherit {...textProps} ref={ref} style={style}>
        {children}
      </Text>
    </Tooltip>
  );
}
